module.exports = __webpack_public_path__ + "static/media/fireflies.09a2656a.svg";